import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useData, useStatus, isLoading, combineStatuses } from 'resift';
import makeGetRole from 'fetches/rolesAndPermissions/makeGetRole';
import makeGetPermissionScopedEntities from 'fetches/rolesAndPermissions/makeGetPermissionScopedEntities';
import makeGetUserFieldsFetch from 'fetches/makeGetUserFieldsFetch';
import makeCreatePermissionForRole from 'fetches/rolesAndPermissions/makeCreatePermissionForRole';
import CircularProgress from '@material-ui/core/CircularProgress';
import ManagePermissionPage from './ManagePermissionPage';

function Container() {
  const dispatch = useDispatch();
  const getUserFields = makeGetUserFieldsFetch();
  const userFields = useData(getUserFields);
  const getUserFieldsStatus = useStatus(getUserFields);
  const { roleId, permissionId } = useParams<{ roleId: string; permissionId: string }>();
  const getRole = makeGetRole(roleId);
  const getPermissionScopedEntities = makeGetPermissionScopedEntities(roleId, permissionId);
  const createPermissionForRole = makeCreatePermissionForRole(roleId);

  const permissionScopedEntitiesResponse = useData(getPermissionScopedEntities);
  const getPermissionScopedEntitiesStatus = useStatus(getPermissionScopedEntities);

  const role = useData(getRole);
  const getRoleStatus = useStatus(getRole);

  const createPermissionForRoleStatus = useStatus(createPermissionForRole);

  const status = combineStatuses(
    getPermissionScopedEntitiesStatus,
    getRoleStatus,
    createPermissionForRoleStatus,
    getUserFieldsStatus,
  );

  useEffect(() => {
    permissionId && dispatch(getPermissionScopedEntities());

    if (!role) {
      dispatch(getRole());
    }
  }, [dispatch, getPermissionScopedEntities, permissionId, getRole, role]);

  useEffect(() => {
    if (!userFields) {
      dispatch(getUserFields());
    }
  }, []);

  if (isLoading(status)) {
    return <CircularProgress color="secondary" />;
  }

  return (
    <ManagePermissionPage
      role={role}
      permissionId={permissionId}
      permissionScopedEntitiesResponse={permissionScopedEntitiesResponse}
    />
  );
}

export default Container;
